"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshotBanner = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../gen-src/Localize");
var SvgIcon_1 = require("../resources/SvgIcon");
var SnapshotBanner = function (props) {
    var baseStyle = bannerBaseStyle(!!props.isSmallCard);
    var hoverStyle = bannerHoverStyle(!!props.isSmallCard);
    var bannerStyle = !!props.isExpanded ? hoverStyle : baseStyle;
    var getTooltipContent = function () { return React.createElement("span", null, props.tooltipText); };
    var bannerElement = (React.createElement("div", { "data-tb-test-id": "metric-card-snapshot-idk", className: bannerStyle },
        React.createElement(SvgIcon_1.SvgIcon, { name: SvgIcon_1.SvgIconName.CAMERA, altText: "", style: imageStyle(!!props.isSmallCard), color: '#FFFFFF' }),
        React.createElement("div", { style: textStyle }, Localize_1.Messages.Snapshot())));
    // We only need to show the tooltip while the banner is expanded, but we also don't want to
    // show it when it's not expanded since the tooltip will look like it's in the incorrect
    // place then.
    var shouldIncludeTooltip = props.tooltipText !== undefined && props.isExpanded;
    return (React.createElement("div", { style: anchoringContainerStyle }, shouldIncludeTooltip ? (React.createElement(widgets_1.Tooltip, { getContent: getTooltipContent, position: widgets_1.TooltipPosition.Bottom }, bannerElement)) : (bannerElement)));
};
exports.SnapshotBanner = SnapshotBanner;
var BANNER_HEIGHT = 28; // 28 is the height of the recommendation card banners
var SMALL_BANNER_HEIGHT = 24; // smaller height on preview cards so it doesn't overlap BAN
var ICON_WIDTH = 14;
var bannerBaseStyle = function (isSmallCard) {
    return (0, typestyle_1.style)({
        display: 'inline-flex',
        alignItems: 'center',
        position: 'relative',
        background: '#4C86A9',
        zIndex: 4,
        left: "calc(100% - " + (isSmallCard ? SMALL_BANNER_HEIGHT : BANNER_HEIGHT) + "px)",
        transition: 'transform .5s',
        paddingRight: '10px',
        height: isSmallCard ? SMALL_BANNER_HEIGHT + "px" : BANNER_HEIGHT + "px",
        fontWeight: 500,
        $nest: {
            '&:focus, &:focus-visible': {
                boxShadow: '0 0 4px 0 #3498db',
                outline: 'none',
            },
        },
    });
};
var bannerHoverStyle = function (isSmallCard) {
    return (0, typestyle_1.classes)(bannerBaseStyle(isSmallCard), (0, typestyle_1.style)({
        transform: 'translate(calc(28px - 100%), 0)',
        transition: 'transform .5s',
    }));
};
var anchoringContainerStyle = {
    position: 'absolute',
    width: '100%',
};
var textStyle = {
    paddingTop: '2px',
    float: 'right',
    fontSize: widgets_1.TabStyles.Typography.Sizing.Small,
    color: widgets_1.TabStyles.Typography.Color.InvertedPrimary,
    pointerEvents: 'none',
};
var imageStyle = function (isSmallCard) {
    var bannerHeight = isSmallCard ? SMALL_BANNER_HEIGHT : BANNER_HEIGHT;
    return { margin: "0 " + Math.ceil((bannerHeight - ICON_WIDTH) / 2) + "px" };
};
//# sourceMappingURL=SnapshotBanner.js.map